import React, { useEffect, useState } from "react";
import { applyUpdate, dismissBanner, getUpdateState, shouldShowBanner, subscribe } from "../utils/swUpdate";

// "New version of JobQ, tap to reload" (utils/swUpdate.js). Shown on every attended page,
// desktop and phone. The phone shell sets --jq-bottom-inset so it sits above the bottom tabs.
// Kiosk routes (/laser/, /station-feed/) never show it: nobody there can tap it.
const KIOSK_PREFIXES = ["/laser/", "/station-feed/", "/tv/"];

export default function UpdateBanner() {
  const [state, setState] = useState(getUpdateState);
  const [busy, setBusy] = useState(false);

  useEffect(() => subscribe(setState), []);

  const kiosk = KIOSK_PREFIXES.some((p) => window.location.pathname.startsWith(p));
  if (kiosk || !shouldShowBanner(state)) return null;

  const text = state.waiting
    ? "A new version of JobQ is ready."
    : "JobQ was updated in another tab.";

  return (
    <div className="jq-update-banner" role="status" aria-live="polite" data-testid="update-banner">
      <i className="fas fa-sync-alt" aria-hidden="true" />
      <span className="jq-update-banner-text">{text}</span>
      <button
        type="button"
        className="btn btn-sm btn-primary"
        disabled={busy}
        onClick={() => { setBusy(true); applyUpdate(); }}
      >
        {busy ? "Reloading…" : "Tap to reload"}
      </button>
      <button type="button" className="btn btn-sm btn-link jq-update-banner-later" onClick={dismissBanner}>
        Later
      </button>
    </div>
  );
}
